module.exports = __webpack_public_path__ + "web_static/img/smart3.2aaedd66.png";